import React, { useState } from "react";
import {
    Box,
    Grid,
    Paper,
    Typography,

} from "@mui/material";

import { PieChart } from '@mui/x-charts/PieChart';
import { BarChart } from '@mui/x-charts/BarChart';


export const  PlannerEventStats = () => {
    // Datos simulados que emulan la respuesta del API
    const salesData = {
        "2024-06-06": 10,
        "2024-08-06": 15,
        "2024-10-06": 20,
        "2024-12-06": 25,
        "2025-02-06": 30
    };

    const dataset = Object.keys(salesData).map(date => ({
        date,
        sales: salesData[date]
    }));

    const chartSetting = {
        xAxis: [
            {
                dataKey: 'date', // Usar la fecha como clave en el eje X
                scaleType: 'band', // Escala de banda para las fechas
                label: 'Fecha'
            },
        ],
        yAxis: [
            {
                label: 'Ventas',
                scaleType: 'linear', // Escala lineal para los valores de ventas
            }
        ],
        width: 500,
        height: 300,
    };

    const valueFormatter = (value: number | null) => `${value} ventas`; // Formatear las etiquetas de valores



    return (
        <Box>
            <Grid container spacing={4} alignItems="center" mb={2} pt={2}>
                <Grid item xs={12}>
                    <Typography
                        sx={{ fontWeight: 500, fontSize: 40,  }}
                    >
                        Estadisticas del evento
                    </Typography>
                    <Typography
                        variant="body1"
                        sx={{ fontWeight: 400, fontSize: 14,  }}
                    >
                        Aquí encontrarás toda la información relevante de tu evento

                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Paper
                        elevation={6}
                        sx={{
                            padding: 4,
                            borderRadius: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                        <Typography variant="body2" color="warning.main">
                            Total de entradas vendidas
                        </Typography>

                        <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                            25
                        </Typography>
                    </Paper>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Paper
                        elevation={6}
                        sx={{
                            padding: 4,
                            borderRadius: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                        <Typography variant="body2" color="warning.main">
                            Total de ingresos generados
                        </Typography>

                        <Typography variant="h6" sx={{ fontWeight: 500, mt: 2, mb: 2 }}>
                            $500
                        </Typography>
                    </Paper>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Paper
                        elevation={6}
                        sx={{
                            padding: 4,
                            borderRadius: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                        <Typography variant="body2" color="warning.main">
                            Entradas vendidas por tipo
                        </Typography>
                        <br />
                        <PieChart
                            series={[
                                {
                                    data: [
                                        { id: 0, value: 10, label: 'Entrada A' },
                                        { id: 1, value: 15, label: 'Entrada B' },
                                        { id: 2, value: 20, label: 'Entrada C' },
                                    ],
                                },
                            ]}
                            width={400}
                            height={200}
                        />
                    </Paper>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Paper
                        elevation={6}
                        sx={{
                            padding: 4,
                            borderRadius: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                        <Typography variant="body2" color="warning.main">
                            Ingresos por tipo de entrada
                        </Typography>
                        <br />
                        <PieChart
                            series={[
                                {
                                    data: [
                                        { id: 0, value: 10, label: 'Entrada A' },
                                        { id: 1, value: 15, label: 'Entrada B' },
                                        { id: 2, value: 20, label: 'Entrada C' },
                                    ],
                                },
                            ]}
                            width={400}
                            height={200}
                        />

                    </Paper>
                </Grid>

                <Grid item xs={12} sm={12}>
                    <Paper
                        elevation={6}
                        sx={{
                            padding: 4,
                            borderRadius: 3,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >

                        <Typography variant="body2" color="warning.main">
                            Ventas por día
                        </Typography>


                        <BarChart
                            dataset={dataset}
                            series={[{ dataKey: 'sales', label: 'Ventas por día', valueFormatter }]}
                            {...chartSetting}
                        />

                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
};
